"use client";
import { Loader2 } from "lucide-react";
import { useLoading } from "@/contexts/LoadingContext";

export function GlobalLoadingOverlay() {
  const { isLoading, message } = useLoading();

  if (!isLoading) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      aria-busy="true"
      className="bg-background/60 fixed inset-0 z-[9999] flex items-center justify-center backdrop-blur-sm"
    >
      <div className="bg-card flex flex-col items-center gap-3 rounded-lg px-6 py-5 shadow-lg">
        <Loader2
          className="text-primary size-8 animate-spin motion-reduce:animate-none"
          aria-hidden="true"
        />
        <p className="text-muted-foreground text-sm">
          {message ?? "読み込み中…"}
        </p>
      </div>
    </div>
  );
}
